<template>
  <SkeletonLoader>
    <div class="forms-skeleton">
      <!-- Header: title + 2 action buttons -->
      <div class="forms-skeleton__header">
        <div class="sk-line sk-line--title" style="width: 22%;"></div>
        <div class="forms-skeleton__header-actions">
          <div class="sk-rect" style="width: 140px; height: 38px; border-radius: 6px;"></div>
          <div class="sk-rect" style="width: 150px; height: 38px; border-radius: 6px;"></div>
        </div>
      </div>

      <!-- Forms Panel -->
      <div class="forms-skeleton__panel">
        <!-- Panel header: "Your Forms" subtitle + search input -->
        <div class="forms-skeleton__panel-header">
          <div class="sk-line sk-line--lg" style="width: 120px;"></div>
        </div>

        <!-- Search bar -->
        <div class="forms-skeleton__search">
          <div class="sk-rect" style="width: 100%; height: 38px; border-radius: 6px;"></div>
        </div>

        <!-- Table header: 5 columns -->
        <div class="forms-skeleton__table-header">
          <div class="sk-col" style="flex: 3;">
            <div class="sk-line sk-line--sm" style="width: 45%;"></div>
          </div>
          <div class="sk-col forms-skeleton__hide-mobile" style="flex: 1;">
            <div class="sk-line sk-line--sm" style="width: 40%;"></div>
          </div>
          <div class="sk-col forms-skeleton__hide-mobile" style="flex: 1;">
            <div class="sk-line sk-line--sm" style="width: 50%;"></div>
          </div>
          <div class="sk-col forms-skeleton__hide-mobile" style="flex: 2;">
            <div class="sk-line sk-line--sm" style="width: 45%;"></div>
          </div>
          <div class="sk-col" style="flex: 1; text-align: right;">
            <div class="sk-line sk-line--sm" style="width: 50%; margin-left: auto;"></div>
          </div>
        </div>

        <!-- 6 form rows -->
        <div
          v-for="i in 6"
          :key="'row-' + i"
          class="forms-skeleton__row"
        >
          <div class="sk-col" style="flex: 3;">
            <div class="sk-line" :style="{ width: rowNameWidths[i] }"></div>
          </div>
          <div class="sk-col forms-skeleton__hide-mobile" style="flex: 1;">
            <div class="sk-line sk-line--sm" :style="{ width: rowLangWidths[i] }"></div>
          </div>
          <div class="sk-col forms-skeleton__hide-mobile" style="flex: 1;">
            <div class="sk-line sk-line--sm" :style="{ width: rowPacketWidths[i] }"></div>
          </div>
          <div class="sk-col forms-skeleton__hide-mobile" style="flex: 2;">
            <div class="sk-line sk-line--sm" :style="{ width: rowDateWidths[i] }"></div>
          </div>
          <div class="sk-col" style="flex: 1;">
            <div class="forms-skeleton__actions">
              <div class="sk-rect" style="width: 28px; height: 28px; border-radius: 4px;"></div>
              <div class="sk-rect" style="width: 28px; height: 28px; border-radius: 4px;"></div>
              <div class="sk-rect" style="width: 28px; height: 28px; border-radius: 4px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'FormsHomeSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      rowNameWidths: { 1: '72%', 2: '55%', 3: '80%', 4: '63%', 5: '70%', 6: '48%' },
      rowLangWidths: { 1: '35%', 2: '45%', 3: '30%', 4: '40%', 5: '35%', 6: '50%' },
      rowPacketWidths: { 1: '40%', 2: '30%', 3: '50%', 4: '35%', 5: '45%', 6: '30%' },
      rowDateWidths: { 1: '65%', 2: '55%', 3: '70%', 4: '60%', 5: '50%', 6: '68%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.forms-skeleton {
  padding: 20px;
}

.forms-skeleton__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.forms-skeleton__header-actions {
  display: flex;
  gap: 10px;
}

.forms-skeleton__panel {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
}

.forms-skeleton__panel-header {
  margin-bottom: 16px;
}

.forms-skeleton__search {
  margin-bottom: 20px;
  max-width: 320px;
}

.forms-skeleton__table-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 2px solid #e2e8f0;
}

.forms-skeleton__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 12px;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
}

.forms-skeleton__actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.forms-skeleton__hide-mobile {
  display: block;
}

/* Mobile */
@media (max-width: 768px) {
  .forms-skeleton {
    padding: 12px;
  }

  .forms-skeleton__header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .forms-skeleton__header-actions {
    flex-direction: column;
    width: 100%;

    .sk-rect {
      width: 100% !important;
    }
  }

  .forms-skeleton__search {
    max-width: 100%;
  }

  .forms-skeleton__hide-mobile {
    display: none;
  }
}
</style>
